import { createAction } from 'typesafe-actions'

import { Airport, FullRequestAirHistory, Id, ResumeAir } from 'src/types'

import { AirActionTypes, GetAirType } from './types'

export const getAirports = createAction(
  AirActionTypes.GET_AIRPORTS,
  action => (name: string) => action({ name })
)

export const getAirportsSuccess = createAction(
  AirActionTypes.GET_AIRPORTS_SUCCESS,
  action => (list: Airport[]) => action({ list })
)

export const getAirportsFailure = createAction(
  AirActionTypes.GET_AIRPORTS_FAILURE,
  action => () => action()
)

export const getAir = createAction(
  AirActionTypes.GET_AIR,
  action =>
    ({
      customer_supplier_id,
      date_end,
      date_ini,
      day_end,
      day_ini,
      from_airport,
      num_adults,
      reason_id,
      searchKey,
      searchType,
      to_airport
    }: GetAirType) =>
      action({
        customer_supplier_id,
        date_end,
        date_ini,
        day_end,
        day_ini,
        from_airport,
        num_adults,
        reason_id,
        searchKey,
        searchType,
        to_airport
      })
)

export const getAirSuccess = createAction(
  AirActionTypes.GET_AIR_SUCCESS,
  action =>
    (searchKey: string, resume_air: ResumeAir[], message_id: string[]) =>
      action({
        searchKey,
        resume_air,
        message_id
      })
)

export const getAirFailure = createAction(
  AirActionTypes.GET_AIR_FAILURE,
  action => (searchKey: string, message: string) =>
    action({ message, searchKey })
)

export const getAirHistory = createAction(
  AirActionTypes.GET_AIR_HISTORY,
  action =>
    ({ request_id }: { request_id: Id }) =>
      action({ request_id })
)

export const getAirHistorySuccess = createAction(
  AirActionTypes.GET_AIR_HISTORY_SUCCESS,
  action =>
    ({ historyList }: { historyList: FullRequestAirHistory[] }) =>
      action({ historyList })
)
export const getAirHistoryFailure = createAction(
  AirActionTypes.GET_AIR_HISTORY_FAILURE,
  action => (message: string) => action({ message })
)

export const resetAir = createAction(
  AirActionTypes.RESET_AIR,
  action => () => action()
)
